import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { CustomEventsService } from '@piwikpro/ngx-piwik-pro';

@Injectable({
  providedIn: 'root',
})
export class GAService {
  constructor(
    private $gaService: GoogleAnalyticsService,
    private cookieService: CookieService,
    private $customEventsService: CustomEventsService
  ) {}

  /**
   * Send a google event But check before if user have accepted COOKIES CONSENT.
   * @param {string} eventName
   * @param {string | null} eventCateg
   * @param {string | null} eventLabel
   * @param {number | null} eventValue
   */
  public sendEvent(
    eventName: string,
    eventCateg?: string,
    eventLabel?: string,
    eventValue?: number,
    interaction?: boolean
  ): void {
    if (!this.canSendEvents()) return;
    // this.$gaService.event(eventName, eventCateg, eventLabel, eventValue, interaction);
    this.$customEventsService.trackEvent(
      this.removeAccents(eventCateg?.toLowerCase() ?? ''),
      this.removeAccents(eventName?.toLowerCase() ?? ''),
      this.removeAccents(eventLabel?.toLowerCase() ?? '')
    );
  }

  private removeAccents = (str: string): string =>
    str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  /**
   * Check if user have accepted coockies consent.
   * @returns {boolean}
   */
  private canSendEvents(): boolean {
    return this.cookieService.get('cookieConsent') == 'accepted';
  }
}
